bcl.s.intlTelInput = {
  props: {
    cssSelector: "intlTelInput",
    flatpickrConfig: {},
  },

  preInit: function () {
    bcl.u.docReady(bcl.s.intlTelInput.init);
  },

  init: function (baseDom) {
    bcl.u.loadStyleSheet("/etc.clientlibs/barcelo/clientlibs/clientlib-intlTelInput.css");

    const baseFind = baseDom ? baseDom : document,
      elements = baseFind.querySelectorAll("." + bcl.s.intlTelInput.props.cssSelector);

    bcl.s.intlTelInput.props.flatpickrConfig.initialCountry = bcl.u.getCountryCode();
    bcl.s.intlTelInput.props.flatpickrConfig.preferredCountries = [bcl.s.intlTelInput.props.flatpickrConfig.initialCountry];
    bcl.s.intlTelInput.props.flatpickrConfig.utilsScript = "../libraries/intltelinput/utils.js";

    for (let i = 0; i < elements.length; i++) {
      bcl.s.intlTelInput.process(elements[i]);
    }
  },

  process: function ($element) {
    if (window.intlTelInputGlobals.getInstance($element)) {
      return;
    }
    window.intlTelInput($element, bcl.s.intlTelInput.props.flatpickrConfig);
  },

  getPhone: function ($input) {
    let phone = "";

    if ($input && window.intlTelInputGlobals) {
      const phonePrefix = window.intlTelInputGlobals.getInstance($input).selectedCountryData.dialCode;
      phone = "" + phonePrefix + $input.value;
    }

    return phone;
  },

  validatePhone: function ($input) {
    if ($input && window.intlTelInputGlobals) {
      const instance = window.intlTelInputGlobals.getInstance($input);
      return instance.isValidNumber();
    }
    return false;
  },
};

bcl.preInit.push(bcl.s.intlTelInput.preInit);
